export const BOOKING_COMPONENT="BOOKING_COMPONENT";